<mat-form-field fxLayout="row" class="form-full-width" appearance="outline" [formGroup]="group">
    <mat-label>{{ field.label ? field.label : '' }}</mat-label>

    <input
        matInput
        [formControl]="group.get(field.name)"
        [maxlength]="9"
        [app-restrict-input]="'color'"
        [app-restrict-input-control]="group.get(field.name)"
        [id]="field.id ? field.id : null"
        [readonly]="field.disabled"
    />
    <mat-hint *ngIf="field.hint" [innerHtml]="field.hint"> </mat-hint>

    <fui-button
        matSuffix
        *ngIf="!field?.hideClearButton && group?.get(field.name).value && !field.disabled && !field.is_block"
        (clickEvent)="group?.get(field.name).setValue(''); group?.get(field.name)?.markAsDirty()"
        [title]="appService.language_dictionary.system_clear"
        [disabled]="field.disabled"
        icon="close"
        type="button-icon"
        borderRadius="circle"
        color="neutral"
        height="mini"
        iconSize="16"
    >
    </fui-button>

    <fui-button
        matSuffix
        (colorPickerChange)="group.get(field.name).setValue($event)"
        [colorPicker]="group.get(field.name).value"
        [title]="appService.language_dictionary?.palette_open"
        [textColor]="group.get(field.name).value ?? null"
        [disabled]="field.disabled"
        icon="palette"
        type="button-icon"
        borderRadius="circle"
        color="neutral"
        height="mini"
    >
    </fui-button>

    <ng-container *ngFor="let validation of field.validations" ngProjectAs="mat-error">
        <mat-error
            *ngIf="group?.get(field.name)?.hasError(validation.name)"
            [innerHTML]="
                validation.name === 'serverError' ? group?.get(field.name)?.errors?.serverError : validation.message
            "
        >
        </mat-error>
    </ng-container>
    <mat-error *ngIf="group.get(field.name).hasError('inputMaskError')">
        {{ group.get(field.name).errors?.inputMaskError }}
    </mat-error>
</mat-form-field>
